import { render, staticRenderFns } from "./popup-wrapper.vue?vue&type=template&id=40b4d96b&scoped=true&"
import script from "./popup-wrapper.vue?vue&type=script&lang=js&"
export * from "./popup-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./popup-wrapper.vue?vue&type=style&index=0&id=40b4d96b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b4d96b",
  null
  
)

export default component.exports